import { getNativeConfig } from 'src/config/brandings/oss/nativeConfig.ts'

module.exports = () => {
  return {
    app_name: 'OSS Messenger',
    styles: {
      load: () => import(/* webpackChunkName: "styleOSS" */'src/config/brandings/oss/index.scss')
    },
    meta: {
      meta: [
        { name: 'apple-itunes-app', content: 'app-id=1618783644' },
        { name: 'og:image', content: '/brandings/oss/favicons/favicon-192x192.png' },
        { name: 'twitter:image', content: '/brandings/oss/favicons/favicon-192x192.png' }
      ],
      link: [
        { rel: 'shortcut icon', href: '/brandings/oss/favicons/favicon-32x32.png', type: 'image/png' }
      ]
    },
    logos: {
      logo: 'brandings/oss/logo/oss-logo.svg'
    },
    search: {
      queries: {
        branding: 'OSS'
      }
    },
    start: {
      description: 'branding.oss.start.description',
      image: false,
      show_more: false,
      sdui_authenticator: false
    },
    management: {
      show_announcements: true,
      show_material_page: true,
      additional_content: {
        infos: 'branding.oss.management.additional_content.infos'
      }
    },
    ui: {
      show_hint_cards: true,
      show_video_hint: true
    },
    settings: {
      notifications: {
        email_newsletter: false
      }
    },
    dataProtection: {
      show_go_to_sdui_website: false
    },
    onboarding: {
      help_videos: true
    },
    keepAlivePing: false,
    appSwitcher: {
      show_marketing: false
    },
    login: {
      registration_code: true,
      hideSduiLoginDefault: false,
      sduiLoginDefaultExpanded: false,
      form: {
        inline_reset_password: true
      }
    },
    ...getNativeConfig()
  }
}
